/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalUserNameUpdateRequest
 */
export interface ExternalUserNameUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ExternalUserNameUpdateRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserNameUpdateRequest
     */
    lastName?: string | null;
}

/**
 * Check if a given object implements the ExternalUserNameUpdateRequest interface.
 */
export function instanceOfExternalUserNameUpdateRequest(value: object): value is ExternalUserNameUpdateRequest {
    return true;
}

export function ExternalUserNameUpdateRequestFromJSON(json: any): ExternalUserNameUpdateRequest {
    return ExternalUserNameUpdateRequestFromJSONTyped(json, false);
}

export function ExternalUserNameUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserNameUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'lastName': json['lastName'] === undefined ? undefined : json['lastName'] === null ? null : json['lastName'],
    };
}

export function ExternalUserNameUpdateRequestToJSON(json: any): ExternalUserNameUpdateRequest {
    return ExternalUserNameUpdateRequestToJSONTyped(json, false);
}

export function ExternalUserNameUpdateRequestToJSONTyped(value?: ExternalUserNameUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

